const ISARAYANLAR = [
    {
      "title": "Suat",
      "desciption": "Ankara'ya yeni taşındık. Abimle birlikte boya, badana, alçı ve sıva işlerinde çalışabileceğimiz güvenilir bir iş arıyoruz. Yardımcı olabilecek hemşehrilerimizin iletişime geçmesini rica ederiz.",
      "phone": "0553 071 96 04",
      "category": "Boya, Badana, Alçı, Sıva"
    },
 
  ]
  export default ISARAYANLAR
